import {
  LayoutDashboard, Activity, Store, PlusCircle, BadgeCheck, ShieldCheck, AlertTriangle,
  Scale, CreditCard, FileCog, Server, ScrollText, Users, Bot, Eye,
} from 'lucide-react';
import Dashboard from './pages/Dashboard';
import Risk from './pages/Risk';
import Merchants from './pages/Merchants';
import MerchantWizard from './pages/MerchantWizard';
import MerchantDetail from './pages/merchant/MerchantDetail';
import Onboarding from './pages/Onboarding';
import Moderation from './pages/Moderation';
import Marketplace from './pages/Marketplace';
import Exceptions from './pages/Exceptions';
import Reconciliation from './pages/Reconciliation';
import Plans from './pages/Plans';
import Policies from './pages/Policies';
import Infrastructure from './pages/Infrastructure';
import Audit from './pages/Audit';
import Admins from './pages/Admins';
import Assistants from './pages/Assistants';

/**
 * Super Admin route manifest (owned by the platform surface).
 *   { path, permission, Element, label, icon, group, prd?, nav?: false, navParent?, foot?: 'Short label' }
 * `permission` hides the entry and the page from admins without it (the API enforces it anyway).
 * `self: true` instead marks a page of the admin's own things, open to every admin (D48).
 * `group` = sidebar section; `foot` = short label in the phone bottom bar (max 4 + "More").
 */
export const platformRoutes = [
  { path: '/', permission: 'merchants.view', Element: Dashboard, label: 'Dashboard', icon: LayoutDashboard, group: 'Overview', foot: 'Home' },
  { path: '/risk', permission: 'analytics.view', Element: Risk, label: 'Risk & operations', icon: Activity, group: 'Overview', prd: 'ADMIN-06' },
  { path: '/merchants', permission: 'merchants.view', Element: Merchants, label: 'Merchants', icon: Store, group: 'Merchants', foot: 'Merchants' },
  { path: '/merchants/new', permission: 'merchants.manage', Element: MerchantWizard, label: 'Register merchant', icon: PlusCircle, group: 'Merchants' },
  { path: '/merchants/:id', permission: 'merchants.view', Element: MerchantDetail, label: 'Merchant', nav: false, navParent: '/merchants' },
  { path: '/onboarding', permission: 'onboarding.review', Element: Onboarding, label: 'Seller onboarding', icon: BadgeCheck, group: 'Merchants', prd: 'ADMIN-01', foot: 'KYC' },
  { path: '/moderation', permission: 'listings.moderate', Element: Moderation, label: 'Listing moderation', icon: ShieldCheck, group: 'Marketplace', prd: 'ADMIN-02' },
  // MERCH-89: which industries and product types the marketplace shows (stores are unaffected).
  { path: '/marketplace', permission: 'marketplace.view', Element: Marketplace, label: 'Marketplace toggles', icon: Eye, group: 'Marketplace' },
  { path: '/exceptions', permission: 'exceptions.view', Element: Exceptions, label: 'Order exceptions', icon: AlertTriangle, group: 'Marketplace', prd: 'ADMIN-03', foot: 'Exceptions' },
  { path: '/reconciliation', permission: 'reconciliation.view', Element: Reconciliation, label: 'Reconciliation', icon: Scale, group: 'Finance', prd: 'ADMIN-04' },
  { path: '/plans', permission: 'plans.view', Element: Plans, label: 'Plans & billing', icon: CreditCard, group: 'Finance', prd: 'ADMIN-05' },
  { path: '/policies', permission: 'policies.view', Element: Policies, label: 'Policies & config', icon: FileCog, group: 'Platform', prd: 'ADMIN-05' },
  { path: '/infrastructure', permission: 'infrastructure.view', Element: Infrastructure, label: 'Infrastructure', icon: Server, group: 'Platform' },
  { path: '/audit', permission: 'audit.view', Element: Audit, label: 'Audit log', icon: ScrollText, group: 'Platform' },
  { path: '/admins', permission: 'admins.view', Element: Admins, label: 'Platform admins', icon: Users, group: 'Platform' },
  // No permission: every admin manages their own assistants (D48).
  { path: '/assistants', self: true, Element: Assistants, label: 'AI assistants', icon: Bot, group: 'Platform' },
];
